module.exports = __webpack_public_path__ + "static/media/device.2a03ff9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/screens/Landing/img/device.png
// module id = 1380
// module chunks = 0